module.exports = __webpack_public_path__ + "img/csv.a9cae68b.png";